import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_defined_the_persons_responsible_for_the_implementat'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_defined_the_persons_responsible_for_the_implementat',
  name: 'Has the facility defined the person(s) responsible for the implementation and management of social and labor practices?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_WRITTEN',
      text: 'Responsible person(s) have been defined and are accountable for written policies and/or procedures',
      externalIds: [
        {
          id: 'ms-4-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_',
      text: 'Responsible person(s) have been defined and are accountable for informal (not written) procedures',
      externalIds: [
        {
          id: 'ms-4-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_HAS_NOT_DEFINED_RESPONSIBLE_PERSON_S_',
      text: 'The facility has not defined responsible person(s)',
      externalIds: [
        {
          id: 'ms-4-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_WRITTEN',
                'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_',
                'THE_FACILITY_HAS_NOT_DEFINED_RESPONSIBLE_PERSON_S_',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21050,
  sectionId: '2.2.6.9',
  impactArea: 'Roles and Responsibilities',
  impactAreaId: 'ROLES_AND_RESPONSIBILITIES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
